import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  FunctionField,
  TextInput,
  SelectInput,
} from "react-admin";
import * as React from "react";

// Helper to format short name
const formatPersonShort = (person: any) => {
  if (!person) return "";
  const { lastName, firstName, middleName } = person;
  return `${lastName || ""} ${firstName ? firstName[0] + "." : ""} ${
    middleName ? middleName[0] + "." : ""
  }`.trim();
};

const DEGREE_UA: { [key: string]: string } = {
  BACHELOR: "Бакалавр",
  MASTER: "Магістр",
  COURSE: "Курсова робота",
};

// Filters for the works list
const workFilters = [
  <TextInput source="topic" label="Topic" alwaysOn />,
  <TextInput source="author.fullName" label="Author" />,
  <TextInput source="supervisor.fullName" label="Supervisor" />,
  <TextInput source="year" label="Year" />,
  <SelectInput
    source="degree"
    label="Degree"
    choices={[
      { id: "BACHELOR", name: "Бакалавр" },
      { id: "MASTER", name: "Магістр" },
      { id: "COURSE", name: "Курсова робота" },
    ]}
  />,
  <TextInput source="specialty.name" label="Specialty" />,
];

export const WorkList = () => (
  <List filters={workFilters}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="topic" sx={{ minWidth: 250, maxWidth: 400 }} />
      <FunctionField
        label="Author"
        render={(record: any) => formatPersonShort(record.author)}
      />
      <FunctionField
        label="Supervisor"
        render={(record: any) => formatPersonShort(record.supervisor)}
      />
      <FunctionField
        label="Year"
        render={(record: any) =>
          record.year ? String(record.year).replace(/\D/g, "") : ""
        }
      />
      <FunctionField
        label="Degree"
        render={(record: any) =>
          DEGREE_UA[String(record.degree)] || record.degree
        }
      />
      <FunctionField
        label="Specialty"
        render={(record: any) => record.specialty?.name || ""}
      />
      <EditButton />
    </Datagrid>
  </List>
);
